import type { DocMigration } from "../docMigration";

const ELEVATION_LINEWORK_3D = "ELEVATION_LINEWORK_3D";
const SECTION_LINEWORK_3D = "SECTION_LINEWORK_3D";

const LINEWORK_FILTERABLE_CATEGORIES = [
  "CASEWORK",
  "COLUMN",
  "DOORS",
  "PORCH",
  "PROPS",
  "RAILING",
  "ROOF_LINEWORK_3D",
  "STAIR",
  "WAINSCOTING",
  "WALLS",
  "WINDOWS",
  "SLAB",
  "STEM_WALL",
  "FOUNDATION_FOOTING",
  "FOUNDATION_CURB",
  "FOUNDATION_PIER",
  "TRIM",
];

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_373: DocMigration = {
  maxSchemaVersion: "0.0.373",
  description: "Migrate section views, elevation views and 3D views to support filtering geometries",
  apply(json: any) {
    for (const viewTemplateId in json.viewTemplates) {
      const viewTemplate = json.viewTemplates[viewTemplateId];
      let addLineworkCategories = false;
      if (viewTemplate.categories.includes(ELEVATION_LINEWORK_3D)) {
        viewTemplate.categories.splice(viewTemplate.categories.indexOf(ELEVATION_LINEWORK_3D), 1);
        addLineworkCategories = true;
      }
      if (viewTemplate.categories.includes(SECTION_LINEWORK_3D)) {
        viewTemplate.categories.splice(viewTemplate.categories.indexOf(SECTION_LINEWORK_3D), 1);
        addLineworkCategories = true;
      }
      if (viewTemplate.viewType === "VIEW_3D") {
        addLineworkCategories = true;
      }
      if (addLineworkCategories) {
        viewTemplate.categories.push(...LINEWORK_FILTERABLE_CATEGORIES);
      }
    }
    return json;
  },
};

export default migration_0_0_373;
